module.exports = __webpack_public_path__ + "img/brush.22c1dd31.svg";